import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
    FiX,
    FiCalendar,
    FiClock,
    FiUser,
    FiFileText,
    FiCheckCircle,
} from "react-icons/fi";
import dayjs from "dayjs";
import "../styles/attendance-day-modal.css";

const STATUS_COLOURS = {
    Present: "#16A34A",
    Absent: "#DC2626",
    Late: "#2563EB",
    Excused: "#9333EA",
};

export default function AttendanceDayModal({
    open,
    attendance = [],
    selectedDate,
    onClose,
}) {
    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [open]);

    useEffect(() => {
        function handleEscape(event) {
            if (event.key === "Escape") {
                onClose();
            }
        }

        window.addEventListener("keydown", handleEscape);

        return () => {
            window.removeEventListener("keydown", handleEscape);
        };
    }, [onClose]);

    const overlayAnimation = {
        hidden: {
            opacity: 0,
        },
        visible: {
            opacity: 1,
        },
        exit: {
            opacity: 0,
        },
    };

    const drawerAnimation = {
        hidden: {
            x: "100%",
        },
        visible: {
            x: 0,
        },
        exit: {
            x: "100%",
        },
    };

    return (
        <AnimatePresence>
            {open && (
                <>
                    {/* Overlay */}
                    <motion.div
                        className="attendance-modal-overlay"
                        variants={overlayAnimation}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        onClick={onClose}
                    >

                    {/* Drawer */}
                    <motion.div
                        className="attendance-modal"
                        variants={drawerAnimation}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        transition={{ duration: 0.35 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div  className="attendance-modal-header">
                            <div>
                                <h2>Attendance Details</h2>
                                <p>
                                    {dayjs(selectedDate).format(
                                        "dddd, DD MMMM YYYY"
                                    )}
                                </p>
                            </div>

                            <button
                                className="attendance-close"
                                onClick={onClose}
                            >
                                <FiX />
                            </button>
                        </div>

                        {attendance.length === 0 && (
                            <div className="attendance-empty-modal">
                                <FiCalendar size={55} />

                                <h3>No Attendance Found</h3>

                                <p>
                                    No attendance records exist for this day.
                                </p>
                            </div>
                        )}

                        {attendance.length > 0 && (
                            <div className="attendance-modal-body">
                                {/* Attendance records go here */}

                                <>

                                    {
                                        attendance.map((item) => (

                                            <motion.div

                                                key={item.id}

                                                className="attendance-record-card"

                                                initial={{
                                                    opacity: 0,
                                                    y: 20
                                                }}

                                                animate={{
                                                    opacity: 1,
                                                    y: 0
                                                }}

                                                transition={{
                                                    duration: .25
                                                }}

                                            >

                                                <div className="attendance-record-header">

                                                    <div>

                                                        <h3>

                                                            {item.title}

                                                        </h3>

                                                        <small>

                                                            Attendance Session

                                                        </small>

                                                    </div>

                                                    <span

                                                        className="attendance-status-badge"

                                                        style={{
                                                            background:
                                                                STATUS_COLOURS[item.status]
                                                        }}

                                                    >

                                                        <FiCheckCircle />

                                                        {item.status}

                                                    </span>

                                                </div>

                                                <div className="attendance-record-content">

                                                    <div className="attendance-info-row">

                                                        <FiCalendar />

                                                        <div>

                                                            <label>Date</label>
                                                            

                                                            <span>

                                                                {

                                                                    dayjs(item.attendance_date)

                                                                        .format(

                                                                            "DD MMMM YYYY"

                                                                        )

                                                                }

                                                            </span>

                                                        </div>

                                                    </div>

                                                    <div className="attendance-info-row">

                                                        <FiClock />

                                                        <div>

                                                            <label>Time</label>
                                                            

                                                            <span>

                                                                {item.attendance_time ?? "Not Available"}

                                                            </span>

                                                        </div>

                                                    </div>

                                                    <div className="attendance-info-row">

                                                        <FiUser />

                                                        <div>

                                                            <label>Marked By</label>

                                                          {/*   {JSON.stringify(item)}
 */}
                                                            <span>



                                                                {

                                                                    item.marked_by ??

                                                                    "System"

                                                                }

                                                            </span>

                                                        </div>

                                                    </div>

                                                    <div className="attendance-info-row">

                                                        <FiFileText />

                                                        <div>

                                                            <label>Remark</label>

                                                            <span>

                                                                {

                                                                    item.remark ||

                                                                    "No Remark"

                                                                }

                                                            </span>

                                                        </div>

                                                    </div>

                                                </div>


                                                {
                                                    item.description && (

                                                        <div className="attendance-description">

                                                            <strong>

                                                                Session Description

                                                            </strong>

                                                            <p>

                                                                {item.description}

                                                            </p>

                                                        </div>

                                                    )
                                                }


                                                <div className="attendance-record-footer">

                                                    <span>

                                                        Record #

                                                        {item.id}

                                                    </span>

                                                    <span>

                                                        {item.status}

                                                    </span>

                                                </div>

                                            </motion.div>

                                        ))
                                    }



                                </>



                            </div>



                        )}

                        <div className="attendance-modal-footer">

                            <button

                                className="attendance-close-btn"

                                onClick={onClose}

                            >

                                Close

                            </button>

                        </div>
                    </motion.div>

                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}